import * as React from 'react';

export const LazyModeratedRiskLessThanOneYearExclusion = React.lazy(() => import('./component'));
